<template>
    <div>
        <el-row :gutter="20">
            <h2 style="margin-top:unset;">Except Zipcode Scg</h2>
            <el-col :span="24">
                <el-card shadow="never" style="padding-bottom:20px;">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-input v-model="filters[0].value" placeholder="ค้นหารหัสไปรษณีย์"></el-input>
                        </el-col>
                        <el-col :span="6">
                            <el-select
                                v-model="zipcodeArr"
                                @change="changeZipcode"
                                multiple
                                filterable
                                collapse-tags
                                placeholder="ค้นหา / เพิ่ม Zipcode"
                                :loading="loadingZipcode">
                                    <el-option
                                        v-for="item in zipcodeAll"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                    </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <data-tables
                            :data="data"
                            :filters="filters"
                            class="dataTable"
                            :page-size="10"
                            :pagination-props="{ pageSizes: [10, 20, 50, 100], pagerCount: 5 }">
                            <el-table-column label="รหัสไปรษณีย์" prop="zipcode" width="150">
                            </el-table-column>
                            <el-table-column label="ตำบล" prop="zipcode">
                                <div class="text-md-left" slot-scope="scope">
                                    <div v-for="(item,index) in scope.row.districtList" :key="index" class="text item">
                                        - {{item}}
                                    </div>
                                </div>
                            </el-table-column>
                            <el-table-column label="จัดการ" width="130">
                                <div class="text-md-left" slot-scope="scope">
                                    <el-button-group size="mini">
                                        <el-button type="info" icon="el-icon-edit" size="mini" @click="onShowDetail(scope.row,scope.$index)"></el-button>
                                        <!-- <el-button type="danger" icon="el-icon-delete" size="mini" @click="onDelete(scope.$index)"></el-button> -->
                                    </el-button-group>
                                </div>
                            </el-table-column>
                        </data-tables>
                        </el-col>
                        <el-col :span="12">
                            <el-card class="box-card" v-if="showDetail">
                                <div slot="header" class="clearfix">
                                    <span>{{detailShow.zipcode}}</span> <i class="el-icon-delete" style="color:red;cursor: pointer;" @click="onDeleteZipcode(detailShow.key,detailShow.zipcode)"></i>
                                    <br>
                                      <el-select v-model="detailShow.districtList" multiple collapse-tags @change="onAddDistrict">
                                        <el-option
                                        v-for="(item,index) in options"
                                        :key="index"
                                        :label="item.district"
                                        :value="item.district">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div v-for="(item,index) in detailShow.districtList" :key="index" class="text item">
                                        - {{item}} <i class="el-icon-delete" style="color:red;cursor: pointer;" @click="onDeleteSubDistrict(index,detailShow.key)"></i>
                                </div>
                            </el-card>
                            <el-card v-else>
                                <h1>เลือก Zipcode</h1>
                            </el-card>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-button type="primary" @click="saveExcep">บันทึก</el-button>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import MixinThailandUtility from '@/mixins/thailandUtility.js'
export default {
    name: 'ExceptZipcodeScg',
    mixins: [MixinThailandUtility],
    data () {
        return {
            zipcodeROw: null,
            sortingList: [],
            filters: [
                { prop: 'zipcode', value: '' }
            ],
            zipcodeAdd: null,
            data: [],
            detailShow: {
                zipcode: null,
                districtList: [],
                key: null
            },
            loading: false,
            options: [],
            loadingZipcode: false,
            zipcodeArr: [],
            showDetail: false
        }
    },
    created () {
        this.fetchData()
    },
    methods: {
        async fetchData () {
            let ExceptList = []
            try {
                let res = await fgApi.courier.getExceptZipcode({ courier_provider_id: 1 })
                if (res.success) {
                    for (let [key, value] of Object.entries(res.data.exceptZipcode)) {
                        ExceptList.push({ zipcode: key, districtList: value })
                        this.zipcodeArr.push(String(key))
                    }
                    this.data = ExceptList
                    console.log(this.data)
                }
            } catch (error) {
                console.log(error)
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
        },
        onShowDetail (data, index) {
            this.showDetail = true
            this.options = this.findZipcode(data.zipcode)
            this.detailShow.zipcode = data.zipcode
            this.detailShow.districtList = data.districtList
            this.detailShow.key = index
        },
        onDeleteSubDistrict (key, keyItem) {
            this.$confirm('ยืนยันการลบ ?', 'Warning', {
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก',
                type: 'warning'
            }).then(() => {
                this.data[keyItem].districtList.splice(key, 1)
                this.$notify({
                    title: 'Success',
                    message: 'Delete completed',
                    type: 'success'
                })
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: 'Delete canceled'
                // })
            })
        },
        onAddDistrict (value) {
            this.data[this.detailShow.key].districtList = value
        },
        onDeleteZipcode (key, zipcode) {
            this.$confirm('ยืนยันการลบ ?', 'Warning', {
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก',
                type: 'warning'
            }).then(() => {
                this.zipcodeArr.splice(this.zipcodeArr.indexOf(zipcode), 1)
                this.showDetail = false
                this.data.splice(key, 1)
                this.detailShow = {
                    zipcode: null,
                    districtList: [],
                    key: null
                }
                this.$notify({
                    title: 'Success',
                    message: 'Delete completed',
                    type: 'success'
                })
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: 'Delete canceled'
                // })
            })
        },
        changeZipcode (val) {
            if (val.length > this.data.length) {
                this.data.push({ zipcode: val[val.length - 1], districtList: [] })
            } else {
                this.data.forEach((e, index) => {
                    if (val.indexOf(String(e.zipcode)) === -1) {
                        this.showDetail = false
                        this.detailShow = {
                            zipcode: null,
                            districtList: [],
                            key: null
                        }
                        this.data.splice(index, 1)
                    }
                })
            }
        },
        async saveExcep () {
            this.$loading()
            let exceptZipcode = {}
            this.data.forEach(e => {
                console.log(e)
                exceptZipcode[e.zipcode] = e.districtList.map(s => s)
            })
            let param = {
                courier_provider_id: 1,
                except_zipcode: exceptZipcode
            }
            try {
                let res = await fgApi.courier.updateExceptZipcode(param)
                console.log(res)
                if (res.success) {
                    console.log(res)
                    this.showDetail = false
                    this.$notify.success({
                        title: 'Success',
                        message: 'Saved Completed'
                    })
                }
            } catch (error) {

            }
            this.$loading().close()
        }
    }
}
</script>

<style lang="scss">
.deleteZipcode{
    .el-message-box__content{
        padding: 50px 15px;
        font-size: 20px;
    }
}
.text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 5px;
  }
//   .provinceSelected {
//     width: 267px;
//   .el-select__tags {
//     span {
//       display: none;
//     }
//   }
// }
</style>
